import { UsersApi, USERS_ROUTES } from "@sms/shared/users/users.api";
import { UserData, UsersAuthData } from "@sms/shared/users/users.interface";

import { apiFetch } from "~/app/utils/api-fetch";

class UserService implements UsersApi {
  me(this: void): Promise<UserData> {
    return apiFetch(USERS_ROUTES.me());
  }

  auth(this: void, userAuthData: UsersAuthData): Promise<UserData> {
    return apiFetch(USERS_ROUTES.auth(), { body: JSON.stringify(userAuthData), method: "POST" });
  }

  register(this: void, userAuthData: UsersAuthData): Promise<void> {
    return apiFetch(USERS_ROUTES.register(), {
      body: JSON.stringify(userAuthData),
      method: "POST"
    });
  }
}

export const userService: UserService = new UserService();
